import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';

import { translate } from 'services/i18nService';
import ProfileStore from 'stores/ProfileStore';
import Chip from 'components/Chip/Chip';

import styles from './MobileProfileAttributes.css';


const useStyles = makeStyles({
  root: {
    backgroundColor: '#f5f5f5',
    '&:hover': {
      backgroundColor: '#fff',
      borderColor: '#60AAC6',
    },
    borderRadius: '2px',
    border: '1px solid #e4e4e4',
  },
  label: {
    color: '#3a64a4',
    textTransform: 'capitalize',
  },
});
const MobileProfileAttributes = (props) => {
  const {
    breakLine,
    customChipClass,
    customChipWrapperClass,
    history,
    maxNumberOfAttrShown,
    noMargin,
    showHeader,
  } = props;

  const onClick = (link) => () => {
    history.push(link);
  };

  const classes = useStyles();
  const { performerAttributes } = ProfileStore;

  let shownAttributes = performerAttributes;
  if (maxNumberOfAttrShown) {
    shownAttributes = performerAttributes.slice(0, maxNumberOfAttrShown);
  }

  const chipClasses = customChipClass ? `${classes.root} ${customChipClass}` : classes.root;
  const boxClasses = breakLine ? `${styles.chipItem} ${styles.customBox}` : styles.chipItem;
  const wrapperClasses = classNames({
    [styles.wrapper]: true,
    [styles.noMargin]: noMargin,
  });

  return (
    <Box className={wrapperClasses}>
      {showHeader && (
        <Box className={styles.attributesTitle} component="h3">
          {translate('v2profile.profile.attributes')}
        </Box>
      )}
      <Box className={customChipWrapperClass || styles.chipWrapper}>
        {shownAttributes &&
          shownAttributes.map((attribute, index) => (
            <Fragment key={`${attribute.key}_${attribute.value}`}>
              <Box className={boxClasses}>
                <a href={attribute.link.toLowerCase()}>
                  <Chip
                    classes={{ root: chipClasses, label: classes.label }}
                    clickable={true}
                    icon={<LocalOfferIcon className={styles.offerIcon} fontSize="inherit" />}
                    label={translate(attribute.key + attribute.value)}
                    onClick={onClick(attribute.link.toLowerCase())}
                  />
                </a>
              </Box>
              {index === 2 && breakLine && <br />}
            </Fragment>
          ))}
      </Box>
    </Box>
  );
};

MobileProfileAttributes.propTypes = {
  history: PropTypes.object.isRequired,
  breakLine: PropTypes.bool,
  customChipClass: PropTypes.string,
  customChipWrapperClass: PropTypes.string,
  maxNumberOfAttrShown: PropTypes.number,
  noMargin: PropTypes.bool,
  showHeader: PropTypes.bool,
};

MobileProfileAttributes.defaultProps = {
  breakLine: undefined,
  customChipClass: undefined,
  customChipWrapperClass: undefined,
  maxNumberOfAttrShown: undefined,
  noMargin: false,
  showHeader: false,
};

export default observer(MobileProfileAttributes);
